module.exports = __webpack_public_path__ + "img/accuffr_oct.62695be2.png";